import { useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { EmptyMessage, TablePanel } from "../style";

export default function UserTable({ text, data }) {
  const [orderBy, setOrderBy] = useState("downloadCount");
  const [order, setOrder] = useState("desc");

  const rows = useMemo(() => {
    const list = Array.isArray(data) ? [...data] : [];
    list.sort((a, b) => {
      const av = a[orderBy] ?? 0;
      const bv = b[orderBy] ?? 0;
      if (typeof av === "string") {
        return order === "asc"
          ? av.localeCompare(bv || "")
          : (bv || "").localeCompare(av);
      }
      return order === "asc" ? av - bv : bv - av;
    });
    return list;
  }, [data, orderBy, order]);

  const handleSort = (key) => {
    if (orderBy === key) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(key);
      setOrder("desc");
    }
  };

  const headers = [
    { key: "name", label: text.table.user, sortable: true },
    { key: "email", label: text.table.email, sortable: true },
    { key: "downloadCount", label: text.table.downloads, sortable: true, numeric: true },
    { key: "publishCount", label: text.table.publishes, sortable: true, numeric: true },
  ];

  return (
    <TablePanel>
      <Typography variant="h6">{text.table.title}</Typography>
      {rows.length === 0 ? (
        <EmptyMessage>{text.charts.empty}</EmptyMessage>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {headers.map((h) => (
                  <TableCell key={h.key} align={h.numeric ? "right" : "left"}>
                    <TableSortLabel
                      active={orderBy === h.key}
                      direction={orderBy === h.key ? order : "asc"}
                      onClick={() => handleSort(h.key)}
                    >
                      {h.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.userId} hover>
                  <TableCell>{r.name || "-"}</TableCell>
                  <TableCell>{r.email || "-"}</TableCell>
                  <TableCell align="right">{r.downloadCount ?? 0}</TableCell>
                  <TableCell align="right">{r.publishCount ?? 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </TablePanel>
  );
}
